import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import './CppoEditRequest.css';
import { NewClientRequestForm } from '../newClientRequest/newClientRequestForm';
import { useNavigate } from "react-router-dom";
import { CPPCODELIST } from "../../constants";

export default function CPPRequestFormDetails(this: any, props: any) {
  const navigate = useNavigate();

    function HideDialog() {
        props.CPPEditForm(false);
        setVisibleDiv1(true);
        setVisibleDiv2(false);
        setVisibleDiv3(false);
        setVisibleDiv4(false);
        navigate(CPPCODELIST);
    }
    
    const [requestDetails, setRequestDetails] = useState([]);
    const [isVisibleDiv1, setVisibleDiv1] = useState(true);
    const [isVisibleDiv2, setVisibleDiv2] = useState(false);
    const [isVisibleDiv3, setVisibleDiv3] = useState(false);
    const [isVisibleDiv4, setVisibleDiv4] = useState(false);
   
    useEffect(()=>{
         setRequestDetails(props.requestDetails);
    })

 return (     
    <div>
      <Dialog header=<h3>Edit CPP Request</h3> visible={props.visible} style={{ width: '1400px' }}  modal={true} onHide={HideDialog} >
        <div>
          <NewClientRequestForm showHeader={false} requestDetails={requestDetails}  CPPEditForm={props.CPPEditForm} mode="Edit"></NewClientRequestForm>  
        </div>
      </Dialog>     
    </div>
  )
}
